import { ControlPanelProvider } from '@bs/control-panel'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { PantryProvider } from '@pantry/features'
import type { ReactNode } from 'react'
import { FLAGS } from '~/constants/flags'
import { useAuth } from '~/modules/auth/redux/hook'
import { useActiveStore, useSelectedStore } from '~/redux/hooks/store'
import { useHubspotTracking } from '~/utils/hooks/useHubspotTracking'
import AdminLayout from './Admin'
import PantryAdminLayout from './PantryAdmin'

interface AdminLayoutSelectorProps {
  children: ReactNode
}

const AdminLayoutSelector = ({ children }: AdminLayoutSelectorProps) => {
  const activeStore = useSelectedStore()
  const { actions: authActions } = useAuth()
  const isPantryStoreRevampUI =
    useFeatureIsOn(FLAGS.PANTRY_STORE_REVAMP_UI) &&
    activeStore?.isPantry &&
    activeStore?.enableRevampUIForPantryStore

  const isHubspotEnabled = useFeatureIsOn(FLAGS.BS_ENABLED_HUBSPOT)
  useHubspotTracking(isHubspotEnabled)

  const Layout = isPantryStoreRevampUI ? PantryAdminLayout : AdminLayout

  return (
    <ControlPanelProvider store={activeStore}>
      <PantryProvider
        store={activeStore}
        onRefreshStore={() =>
          (authActions.checkAuthState as unknown as () => void)()
        }
      >
        <Layout>{children}</Layout>
      </PantryProvider>
    </ControlPanelProvider>
  )
}

export default AdminLayoutSelector
